import React, { useEffect } from 'react';
import '../styles/Company.css'; // Company hero section styles

import OurVision from '../components/OurVision';
import OurTeam from '../components/OurTeam';

function Company() {
  useEffect(() => {
    document.title = "Company | Inypeople";
     const iconsStart = document.querySelector('.company-ceo-quote-icons-start');
  const iconsEnd = document.querySelector('.company-ceo-quote-icons');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Animate starting quote from left
        if (iconsStart) iconsStart.classList.add('animate');
        // Animate ending quote from right (with slight delay)
        if (iconsEnd) {
          setTimeout(() => {
            iconsEnd.classList.add('animate');
          }, 200);
        }
      } else {
        if (iconsStart) iconsStart.classList.remove('animate');
        if (iconsEnd) iconsEnd.classList.remove('animate');
      }
    });
  }, { threshold: 0.5 });

  if (iconsStart) observer.observe(iconsStart);

  return () => observer.disconnect();
}, []);

  return (
    <>
      <div className="company-hero-container">
        <div className="company-hero-content">
          <div className="company-content-wrapper">
            <h1 className="company-hero-title-main">
              We are <span className="company-title-highlight">Inypeople.</span><br />
              Transforming Brands Through<br />
              Unforgettable <span className="company-title-underlined">Experience.</span>
            </h1>
            <div className="company-hero-subtitle">
              Reliable, Scalable, and Innovative Solutions.
            </div>
          </div>
        </div>
      </div>

      {/* Our Mission Section */}
      <section className="company-mission-section">
        <div className="company-mission-content">
          <button className="company-mission-btn">Our Mission</button>
          <p className="company-mission-desc">
            At Inypeople, our mission is to drive employee satisfaction and customer success, fostering a culture of growth, innovation, and excellence.
          </p>
          <div className="company-mission-cards">
            <div className="company-mission-card company-mission-card-blue">
              <div className="company-mission-card-number">2+</div>
              <div className="company-mission-card-title">Years of Excellence</div>
              <div className="company-mission-card-text">We connect businesses with mission-critical talent that drives performance, scale, and success.</div>
            </div>
            <div className="company-mission-card company-mission-card-pink">
              <div className="company-mission-card-number">20+</div>
              <div className="company-mission-card-title">Happy Employees</div>
              <div className="company-mission-card-text">More than jobs, we build careers—impacting professionals and growing every day.</div>
            </div>
            <div className="company-mission-card company-mission-card-purple">
              <div className="company-mission-card-number">100+</div>
              <div className="company-mission-card-title">Trusted Clients</div>
              <div className="company-mission-card-text">We continue to onboard clients steadily through seamless communication and a collaborative engagement model.</div>
            </div>
          </div>
        </div>
      </section>
      {/* CEO Section */}
      <section className="company-ceo-section">
        {/* Only the bottom right vector stays here */}
        <img src="/assets/images/vector-bottom-left.png" alt="" className="ceo-vector ceo-vector-bottom-left" aria-hidden="true" />
        <div className="company-ceo-container">
          <div className="company-ceo-image-wrapper">
            <img src="/assets/images/vector-top-right.png" alt="" className="ceo-vector ceo-vector-top-right" aria-hidden="true" />
            <img src="/assets/team/Rajeshwaran_p.jpeg" alt="Rajeshwaran P" className="company-ceo-image" />
          </div>
          <div className="company-ceo-quote-card">
            <div className="company-ceo-quote-row">
             <div className="company-ceo-quote">
              <span className="company-ceo-quote-icons-start">
                <img
                  src="/assets/icons/time_section_quote.png"
                  alt="Quote"
                  className="company-ceo-quote-icon-img-start"
                />
              </span>
                Your network is your net worth – and people are the foundation of every successful brand.
                Our success over the last 5+ years is built on people and partnerships.
              <span className="company-ceo-quote-icons">
                <img
                  src="/assets/icons/time_section_quote.png"
                  alt="Quote"
                  className="company-ceo-quote-icon-img"
                />
              </span>
            </div>
            </div>
            <div className="company-ceo-name">
              <span className="company-ceo-name-highlight">Rajeshwaran P</span>
            </div>
            <div className="company-ceo-title-row">
              <span className="company-ceo-title">Founder &amp; CEO</span>
            </div>
            <a href="https://linkedin.com/in/rajeshwaran-p-235266141" target="_blank" rel="noopener noreferrer" className="company-ceo-linkedin-float">
              <img src="/assets/icons/linkedin.png" alt="LinkedIn" />
            </a>
          </div>
        </div>
      </section>
      <OurVision />
      <OurTeam />
      {/* Our Values Section */}
      <section className="company-values-section">
        <div className="company-values-content">
          <button className="company-values-btn">Our Values</button>
          <p className="company-values-desc">
            Collaborating with purpose. Empowering people. Transforming futures.
          </p>
          <div className="company-values-cards">
            <div className="company-values-card">
              <div className="company-values-card-icon" style={{ background: '#2684FF' }}>
                <img src="/assets/icons/collaborate.png" alt="Collaborate" width={30} height={30} />
              </div>
              <div className="company-values-card-title">Collaborate</div>
              <div className="company-values-card-text">We believe the best outcomes are created together. By working closely with clients, candidates, and partners, we foster open communication, shared ownership, and mutual trust.</div>
            </div>
            <div className="company-values-card">
              <div className="company-values-card-icon" style={{ background: '#00C49A' }}>
                <img src="/assets/icons/empower.png" alt="Empower" width={30} height={30} />
              </div>
              <div className="company-values-card-title">Empower</div>
              <div className="company-values-card-text">People are at the heart of everything we do. We empower individuals by creating opportunities, building skills, and enabling confidence.</div>
            </div>
            <div className="company-values-card">
              <div className="company-values-card-icon" style={{ background: '#7C4DFF' }}>
                <img src="/assets/icons/transform.png" alt="Transform" width={30} height={30} />
              </div>
              <div className="company-values-card-title">Transform</div>
              <div className="company-values-card-text">Through innovation, insight, and ethical practices, we help organizations and individuals transform their potential into measurable progress and long-term success.</div>
            </div>
          </div>
        </div>
      </section>
      {/* Company Values Blue Section */}
      <section className="company-values-blue-section">
        <div className="company-values-blue-content">
          <h2 className="company-values-blue-title">
            Driven by innovation and performance, our mission is to build distinctive innovative solutions that enable businesses to scale with speed, agility, and long-term success.
          </h2>
        </div>
      </section>
      {/* Life at Inypeople Section */}
      <section className="company-life-section">
        <div className="company-life-content">
          <h2 className="company-life-title">Life at Inypeople</h2>
          <p className="company-life-desc">
            At Inypeople, we don’t just focus on results—we focus on people. By prioritizing employee happiness and workplace wellbeing, we create a culture that’s vibrant, engaging, and empowering.<br />
            <span className="company-life-desc-sub">That’s how we grow—together.</span>
          </p>
          <div className="company-life-gallery">
            <div className="company-life-row company-life-row-1">
              <img src="/assets/images/life1.jpg" alt="Life at Inypeople 1" className="company-life-img" />
              <img src="/assets/images/life2.jpg" alt="Life at Inypeople 2" className="company-life-img" />
              <img src="/assets/images/life3.jpg" alt="Life at Inypeople 3" className="company-life-img" />
              <img src="/assets/images/life4.jpg" alt="Life at Inypeople 4" className="company-life-img" />
            </div>
            <div className="company-life-row company-life-row-2">
              <img src="/assets/images/life5.jpg" alt="Life at Inypeople 5" className="company-life-img" />
              <img src="/assets/images/life6.jpg" alt="Life at Inypeople 6" className="company-life-img" />
              <img src="/assets/images/life7.jpg" alt="Life at Inypeople 7" className="company-life-img" />
            </div>
            <div className="company-life-row company-life-row-3">
              <img src="/assets/images/life8.jpg" alt="Life at Inypeople 8" className="company-life-img" />
              <img src="/assets/images/life9.jpg" alt="Life at Inypeople 9" className="company-life-img" />
              <img src="/assets/images/life10.jpg" alt="Life at Inypeople 10" className="company-life-img" />
              <img src="/assets/images/life11.jpg" alt="Life at Inypeople 11" className="company-life-img" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Company;